import type { EntityTemplateEntity } from "@/entities/entity-template";
import type { AssetTypeTemplateFormValues } from "@/modules/asset-type-template/asset-type-template-form";
import type { ApiPayloadCreate } from "@/services/api";

import { useTranslation } from "react-i18next";

import { useCreateEntityTemplate } from "@/entities/entity-template";
import { useNavigateToRessource } from "@/hooks/useNavigateToRessource";
import AssetTypeTemplateForm from "@/modules/asset-type-template/asset-type-template-form";

const AssetTypeTemplateCreate = () => {
  const { t } = useTranslation();

  const mutation = useCreateEntityTemplate();
  const saveButtonLabel = t("global:add");

  const initialValues: AssetTypeTemplateFormValues = {
    name: "",
  };

  const onNavigateToTemplate = useNavigateToRessource<
    ApiPayloadCreate<EntityTemplateEntity>
  >("technicalform", (response) => response.data.data.id);

  return (
    <AssetTypeTemplateForm
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
      onMutate={onNavigateToTemplate}
    />
  );
};

export default AssetTypeTemplateCreate;
